import { signal } from "@preact/signals";
export const isDiscoveryOpen = signal(false);
export const isReflectionTabOpened = signal(false);
